export default "__VITE_ASSET__EQeu6F0p__"